module.exports = __webpack_public_path__ + "static/media/sunset-investing-screenshot-6.dbbcf4e5.jpg";